/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { BackTop, Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

const initial = {
    hrDataSubjectRightId: null,
    hrDataSubjectRightTitleTh: 'สิทธิของเจ้าของข้อมูล',
    hrDataSubjectRightTitleEn: 'Rights as a data subject',
    hrDataSubjectRightContentTh: '',
    hrDataSubjectRightContentEn: '',
    hrDataSubjectRightIsDisplay: true,
};

export default function Step7(props) {
    const { setStep7, editData } = props;
    const { t } = useTranslation(['hr-policy']);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep7(true);
            })
            .catch(() => setStep7(false));
        props.nextStep();
    };
    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'hrDataSubjectRightTitleTh',
                'hrDataSubjectRightTitleEn',
                'hrDataSubjectRightContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.hrDataSubjectRight
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                    return;
                }
            }
            setStep7(check);
        }
    }, [editData]);

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Data Subject Rights')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="hrDataSubjectRight"
                layout="vertical"
                form={props?.form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'hrDataSubjectRightTitleTh',
                        'hrDataSubjectRightTitleEn',
                        'hrDataSubjectRightContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep7(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Data Subject Rights')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrDataSubjectRightTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input size="large" showCount maxLength={200} />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`ภายใต้บทบัญญัติแห่งกฎหมายและข้อยกเว้นตามกฎหมายที่เกี่ยวข้อง เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิเกี่ยวกับข้อมูลส่วนบุคคลของตนดังต่อไปนี้\n\n1) การเข้าถึง เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิในการขอเข้าถึงหรือขอรับสำเนาข้อมูลส่วนบุคคลของตนที่บริษัทฯ เก็บรวบรวม ใช้และ/หรือเปิดเผย ทั้งนี้ เพื่อความเป็นส่วนตัวและความปลอดภัยของเจ้าของข้อมูลส่วนบุคคล บริษัทฯ อาจขอให้มีการพิสูจน์ตัวตนก่อนจะให้ข้อมูลส่วนบุคคลตามที่ร้องขอ\n\n2) การแก้ไขให้ถูกต้อง เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิขอให้บริษัทฯ ดำเนินการแก้ไขข้อมูลส่วนบุคคลของตนที่บริษัทฯ ได้เก็บรวบรวมใช้และ/หรือเปิดเผย ซึ่งไม่สมบูรณ์ ไม่ถูกต้อง ก่อให้เกิดความเข้าใจผิด หรือไม่เป็นปัจจุบัน\n\n3) การโอนย้ายข้อมูลส่วนบุคคล เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิขอรับข้อมูลส่วนบุคคลของตนที่บริษัทฯ มีเกี่ยวกับเจ้าของข้อมูลส่วนบุคคลในรูปแบบที่มีการจัดระเบียบแล้วและสามารถอ่านได้ในรูปแบบอิเล็กทรอนิกส์ และเพื่อส่งหรือโอนข้อมูลส่วนบุคคลดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น โดยต้องเป็น (ก) ข้อมูลส่วนบุคคลที่ได้ให้กับบริษัทฯ และ (ข) กรณีที่บริษัทฯ ได้รับความยินยอมในการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลหรือเพื่อปฏิบัติตามสัญญาที่บริษัทฯ มีกับเจ้าของข้อมูลส่วนบุคคล\n\n4) การคัดค้าน เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิคัดค้านการเก็บรวบรวม ใช้และ/หรือเปิดเผยข้อมูลส่วนบุคคล ทั้งนี้ เป็นไปตามที่กฎหมายที่ใช้บังคับกำหนด\n\n5) การระงับการใช้ เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลของตน หากเจ้าของข้อมูลส่วนบุคคลเชื่อว่าข้อมูลส่วนบุคคลดังกล่าวไม่ถูกต้อง การเก็บรวบรวม ใช้ และ/หรือเปิดเผยโดยบริษัทฯ ไม่ชอบด้วยกฎหมาย หรือข้อมูลส่วนบุคคลดังกล่าวหมดความจำเป็นสำหรับวัตถุประสงค์บางประการ\n\n6) การถอนความยินยอม สำหรับวัตถุประสงค์ที่เจ้าของข้อมูลส่วนบุคคลได้ให้ความยินยอมแก่บริษัทฯ ในการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคล เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิที่จะถอนความยินยอมเมื่อใดก็ได้\n\n7) การลบหรือทำลาย เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิขอให้บริษัทฯ ดำเนินการลบ ทำลาย หรือทำให้ข้อมูลส่วนบุคคลที่บริษัทฯ\nเก็บรวบรวม ใช้และ/หรือเปิดเผย เป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลได้ เว้นเสียแต่ว่า การเก็บรักษาข้อมูลส่วนบุคคลดังกล่าวของบริษัทฯ นั้นเป็นไปเพื่อการปฏิบัติตามกฎหมาย หรือเพื่อก่อตั้งสิทธิเรียกร้องตามกฎหมาย เพื่อการใช้ หรือการปกป้องสิทธิเรียกร้องตามกฎหมาย และ\n\n8) การร้องเรียน เจ้าของข้อมูลส่วนบุคคลอาจมีสิทธิร้องเรียนไปยังหน่วยงานของรัฐที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคล ในกรณีที่เจ้าของข้อมูลส่วนบุคคลเชื่อว่าการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของบริษัทฯ ไม่ชอบด้วยกฎหมายหรือไม่สอดคล้องกับกฎหมายคุ้มครองข้อมูลที่บังคับใช้`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrDataSubjectRightContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodThPl', {
                            ns: 'translation',
                        })}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrDataSubjectRightTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input size="large" showCount maxLength={200} />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`Subject to applicable laws and exceptions thereof, a data subject may have the following rights to:\n\n1) Access: Data subjects may have the right to access or request a copy of the Personal Data we are collecting, using and/or disclosing. For privacy and security, we may require proof of the data subject’s identity before providingthe requested Personal Data;\n\n2) Rectification: Data subjects may have the right to have incomplete, inaccurate, misleading, or not up-to-date Personal Data that we collect, use and/or disclose rectified;\n\n3) Data Portability: Data subjects may have the right to obtain Personal Data we hold about that data subject,in a structured, electronic format, and to transmit such data to another data controller, where this is (a) Personal Data which you have provided to us, and (b) if we are collecting, using and/or disclosing that data on the basis of data subject’s consent or to perform a contract with the data subject;\n\n4) Objection: Data subjects may have the right to object to certain collection, use and/or disclosure of Personal Data subject to the applicable law;\n\n5) Restriction: Data subjects may have the right to restrict our use of Personal Data where the data subject believes such Personal Data to be inaccurate, that our collection, use and/or disclosure is unlawful, or that we no longer need such Personal Data for a particular purpose;\n\n6) Withdraw Consent: For the purposes the data subjects have consented to our collection, use and/or disclosureof Personal Data, data subjects may have the right to withdraw consent at any time;\n\n7) Deletion: Data subjects may have the right to request that we delete, destroy or anonymize Personal Data that we collect, use, and/or disclose, except we are not obligated to do so if we need to retain such Personal Data in order to comply with a legal obligation or to establish, exercise or defend legal claims; and\n\n8) Lodge a complaint: Data subjects may have the right to lodge a complaint to the competent authority where the data subject believes our collection, use and/or disclosure of Personal Data is unlawful or non-compliance with applicable data protection law.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrDataSubjectRightContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor size="large" rows={4} />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onNextStep}
                                className="ml-4"
                            >
                                {t('policy.NextStep', { ns: 'translation' })}{' '}
                                <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
